import {
    Button,
    Center,
    Icon,
    IconButton,
    Input,
    InputGroup,
    InputRightElement,
    ModalFooter,
    SimpleGrid,
    Text,
    useId
} from '@chakra-ui/react'
import ArrowRight from 'components/Icon/ArrowRight'
import Close from 'components/Icon/Close'
import Table from 'models/table'
import { ChangeEvent, FormEvent, useState } from 'react'
import ModalContainer from '../libs/ModalContainer'

export interface ModalDinersProps {
    isOpen: boolean
    onClose: () => void
    table: Table
    onDone: (diners: number) => void
}

export default function ModalDiners({
    isOpen,
    onClose,
    table,
    onDone
}: ModalDinersProps) {
    const id = useId()
    const [number, setNumber] = useState(0)
    const [isCustomNumber, setCustomNumber] = useState(false)

    function inputHandler(ev: ChangeEvent<HTMLInputElement>) {
        let value = ev.target.value || '0'
        // Eliminar todo lo que no sea dígito (0-9)
        value = value.replace(/\D+/g, '')

        if (value.search('0') === 0) {
            value = value.slice(1)
        }
        const formated = Number(value)
        setNumber(formated > 99 ? 99 : formated)
    }

    function submitHandler(ev: FormEvent<HTMLFormElement>) {
        ev.preventDefault()
        if (number === 0) return
        onDone(number)
    }

    return (
        <ModalContainer
            title={`Registrar Comensales ${table.name}`}
            onClose={onClose}
            isOpen={isOpen}
            size="sm"
            footer={
                <ModalFooter gap={2}>
                    <Button w="full" onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button
                        w="full"
                        colorScheme="green"
                        type="submit"
                        form={id}
                        disabled={number === 0}
                        rightIcon={<Icon as={ArrowRight} fill="white" />}
                    >
                        Continuar
                    </Button>
                </ModalFooter>
            }
        >
            <Text mb={2} fontSize="sm">
                ¿Cuántos comensales?
            </Text>
            <form id={id} onSubmit={submitHandler} noValidate>
                <SimpleGrid columns={5} gap={2}>
                    {Array.from({ length: 10 }, (_, i) => {
                        const currentNum = i + 1
                        const isActive = number === currentNum
                        return (
                            <Center
                                key={i}
                                fontSize="xl"
                                rounded="md"
                                h={12}
                                bgColor={isActive ? 'blue.400' : 'gray.100'}
                                color={isActive ? 'white' : 'currentcolor'}
                                cursor="pointer"
                                onClick={() => setNumber(currentNum)}
                                transition=".2s ease"
                                _hover={{
                                    bgColor: isActive ? 'blue.400' : 'gray.200'
                                }}
                            >
                                {currentNum}
                            </Center>
                        )
                    })}
                </SimpleGrid>

                {!isCustomNumber && (
                    <Button
                        variant="solid"
                        colorScheme="gray"
                        w="full"
                        mt={4}
                        onClick={() => setCustomNumber(true)}
                    >
                        +Otro número
                    </Button>
                )}
                {isCustomNumber && (
                    <InputGroup size="md" mt={4} w="full">
                        <Input
                            autoFocus
                            max={100}
                            type="number"
                            value={number.toString()}
                            onChange={inputHandler}
                        />
                        <InputRightElement>
                            <IconButton
                                size="sm"
                                aria-label="close"
                                type="button"
                                icon={<Close />}
                                variant="ghost"
                                onClick={() => {
                                    setCustomNumber(false)
                                    setNumber(0)
                                }}
                            />
                        </InputRightElement>
                    </InputGroup>
                )}
            </form>
        </ModalContainer>
    )
}
